const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getSaleStatuses = async () => {
    const token = localStorage.getItem('token');

    try {
        const response = await fetch(
            `${API_BASE_URL}/common/lead/filters/sale-statuses`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data?.message || 'Ошибка при получении списка sale statuses');
        }

        return data; // { data: [...] }
    } catch (error) {
        console.error('Ошибка при получении списка sale statuses:', error);
        throw error;
    }
};
